import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import StationResults from './StationResults';
import RouteMap, { EMPTY_STATIONS } from './RouteMap';
import { Message } from '../types';
import './MessageBubble.css';



export default function MessageBubble({ message, isStreaming }: { message: Message; isStreaming?: boolean }) {
  const isUser = message.role === 'user';
  const time = new Date(message.timestamp || Date.now()).toLocaleTimeString('en-US', {
    hour: '2-digit',
    minute: '2-digit',
  });

const stations = message.stations?.length
  ? message.stations
  : message.tool_data?.find(t => t.data?.stations?.length > 0)?.data.stations ?? EMPTY_STATIONS;

const routeInfo = message.extraction?.route;


  return (
    <div className={`bubble-row ${isUser ? 'user-row' : 'assistant-row'}`}>
      {!isUser && (
        <div className="avatar assistant-avatar">⚡</div>
      )}
      <div className={`bubble ${isUser ? 'user-bubble' : 'assistant-bubble'} ${message.isError ? 'error-bubble' : ''}`}>
        <div className="bubble-content">
          <ReactMarkdown
            remarkPlugins={[remarkGfm]}
            components={{
              table: ({ node, ...props }) => (
                <div className="table-scroll">
                  <table {...props} />
                </div>
              ),
            }}
          >
            {message.content}
          </ReactMarkdown>
          {isStreaming && <span className="streaming-cursor" />}
        </div>

        {(Boolean(message.encodedPolyline?.trim()) || stations.length > 0) && (
          <RouteMap
            encodedPolyline={message.encodedPolyline ?? ''}
            stations={stations}
            startLabel={routeInfo?.origin}
            endLabel={routeInfo?.destination}
          />
        )}


        {stations && stations.length > 0 && (
          <StationResults stations={stations} />
        )}
        {!isStreaming && <span className="bubble-time">{time}</span>}
      </div>
      {isUser && (
        <div className="avatar user-avatar">U</div>
      )}
    </div>
  );
}
